<mat-card class="errorDiv">
    <div>
        <p style="color: red; font-weight: 400; font-size: 2rem;">Error: Testing</p>
    </div>
    <div style="cursor: pointer" (click)="hideErrorComponent(false)">
        X
    </div>
</mat-card>